module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Cb-Db-Ed-Fb-Gd.371a4620.png";